module.exports = __webpack_public_path__ + "img/Rodrigo Seira.83e24d9e.jpg";